<template>
    <div>
        <specialStatis></specialStatis>
        <!-- <serviceStatis></serviceStatis> -->
        <changeStatis></changeStatis>
        <publishStatis></publishStatis>
        <CABStatis></CABStatis>
        <!-- <configStatis></configStatis> -->
    </div>
</template>

<script>

    import reportCss from './report.scss';
    import specialStatis from './specialStatis/index';
    import serviceStatis from './serviceStatis/index';
    import changeStatis from './changeStatis/index';
    import publishStatis from './publishStatis/index';
    import CABStatis from './CABStatis/index';
    import configStatis from './configStatis/index';
    export default {
        components:{
            specialStatis,//特殊统计
            serviceStatis,//服务台统计
            changeStatis,//变更统计
            publishStatis,//发布统计
            CABStatis,//CAB统计
            configStatis,//配置项统计
        }
    }
</script>

<style scoped>

</style>